export const NAV_ITEMS = {
  PostMortem:      { icon: 'fas fa-search-dollar',  colorClass: 'text-success', label: 'Post-Mortem' },
  Watchlist:          { icon: 'fas fa-binoculars',     colorClass: 'text-info',      label: 'Watchlist' },
  OrderHistory:       { icon: 'fas fa-receipt',        colorClass: 'text-warning',   label: 'Orders' },
  WatchlistHistory:   { icon: 'fas fa-history',        colorClass: 'text-info',      label: 'Watchlist History' },
  AdminSettings:      { icon: 'fas fa-sliders-h',      colorClass: 'text-secondary', label: 'Settings' },
  KillSwitch:         { icon: 'fas fa-power-off',      colorClass: 'text-danger',    label: 'Kill Switch' },
  AlpacaImport:       { icon: 'fas fa-cloud-download-alt', colorClass: 'text-primary', label: 'Import Trade History' },
}
